"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PopOverPresentationControl = require("./PopOverPresentationControl");
Object.keys(_PopOverPresentationControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PopOverPresentationControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PopOverPresentationControl[key];
    }
  });
});